import css from './AccordionSummary.module.scss';
import classNames from 'classnames';
import { BaseAccordionSummary } from '../BaseAccordionSummary/BaseAccordionSummary';
import { AccordionSummaryProps } from './AccordionSummary.types';
import { GMGenericIcon } from '../../Icon';

/**
 * This component sets the title, icon, and how the un-expanded bar should behave when the section expands.
 *
 * @param id - {@link AccordionSummaryProps.id id} description.
 * @param ariaControls - {@link AccordionSummaryProps.ariaControls ariaControls} description.
 * @param headingLabel - {@link AccordionSummaryProps.headingLabel headingLabel} description.
 * @param error - {@link AccordionSummaryProps.error error} description.
 * @param expanded - {@link AccordionSummaryProps.expanded expanded} description.
 * @param onClick - {@link AccordionSummaryProps.onClick onClick} description.
 */
const AccordionSummary = ({
    id,
    ariaControls,
    headingLabel,
    error,
    expanded = false,
    onClick,
}: AccordionSummaryProps) => {
    return (
        <BaseAccordionSummary
            id={id}
            ariaExpanded={expanded}
            ariaControls={ariaControls}
            classes={{
                root: classNames(css.header, error ? css.error : null),
                expanded: css.expanded,
                content: css.content,
            }}
            onClick={onClick}
        >
            <h4 className={css.noHeaderStyle}>
                {headingLabel}
            </h4>
            {!expanded ? (
                <GMGenericIcon iconType={'Dropdown'} />
            ) : null}
        </BaseAccordionSummary>
    );
};

export default AccordionSummary;